export default {
  getFunds: 'api/fundos/get-funds'
};
